export default "__VITE_PUBLIC_ASSET__2143e7c8__"